import TeamMembersTable from './TeamMembersTable';

export default TeamMembersTable;
